import axios from "axios"
import { getHeaders } from "services/AuthHeader";
import { ReservationI } from "types/ReservationsI"
import { ReservationResponse } from "types/responses/ReservationResponse";
import { ResponseError } from "types/responses/ResponseError"
const API_URL = process.env.REACT_APP_API_URL;

async function getUserReservations(client_id: any) {
    
    try {

        const response = await axios.get(
            API_URL + '/user/reservations',
            {
                params: {
                    client_id: client_id
                }, 
                headers: getHeaders() 
            }
        )
        // console.log(response);
        
        if (!('reservations' in response.data)) {
            throw Error
        }
        if ('error' in response.data) {
            return response.data.error
        }

        const json: ReservationResponse[] = JSON.parse(response.data.reservations)
        // console.log(json);
        
        let reservations: ReservationI[] = []
        json.forEach((value, index) => {
            let r: ReservationI = {
                name: value?.NAZEV,
                coach: value.INSTRUKTOR,
                coach_id: value.ID_TRENER,
                reservation_source: value.PUVOD,
                sports_ground_id: value.ID_SPORTOVISTE,
                lesson_id: value.ID_LEKCE,
                original_price: value.CENA_ORIGINAL,
                date: new Date(value.DATUM),
                length: value.DELKA,
                description: value.POPIS,
                reservation_date: new Date(value.DATUM_REZERVACE)
            }

            reservations.push(r)
        })
        return reservations

    } catch (error) {
        // console.log(error);
        
        return ResponseError.general_error
    }

}

export default getUserReservations